import React, { Component } from 'react';
import Helmet from "react-helmet";
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import Previous from '../../components/toto/previous';

// @inject('lineStore')
// @withRouter
export default class PreviousPage extends Component { 
	render() {
			return(
				<div className="toto-page">
					<Helmet>
						<title>ИРМ - Предыдущие розыгрыши</title>
					</Helmet>
					<div className="toto-page__body">
						<Previous />
					</div>
				</div> 
			)
	}
}


// WEBPACK FOOTER //
// ./src/routes/toto/previous.jsx